<template>
  <v-container fluid class="fast-switcher">
    <div v-if="idFwMarketgroup">
      <div class="fast_switch_header">
        <h2>{{  marketgroup && marketgroup.marketgroupname ? marketgroup.marketgroupname : event.idfosporttype + ' - ' + idFwMarketgroup}}</h2>
        <v-btn @click="closeDialog()">
          <span>{{ $t('Dialog.btn.CLOSE') }}</span>
        </v-btn>
      </div>
      <div class="events-holder">
        <div class="event"
            v-for="ev in marketgroupEvents"
            :key="ev.idfoevent"
            :class="{'selected': ev.idfoevent.toString() === idFoEvent.toString()}"
            @click.stop="goToEvent(ev, false, false, false, false, false, idFwMarketgroup)"
            >
          <v-flex class="names participants">
            <div class="event-info">
              <section class="parent">
                <section v-if="ev.participantname_away && ev.participantname_home" class="child child-left" >
                  <template v-if="isbig3event">
                    <div class="team-title">{{ ev.participantname_away }}</div>
                    <div class="team-title">{{ ev.participantname_home }}</div>
                  </template>
                  <template v-else>
                    <div class="team-title">{{ ev.participantname_home }}</div>
                    <div class="team-title">{{ ev.participantname_away }}</div>
                  </template>
                </section>
                <section v-else class="child child-left" >
                  <div class="team-title">{{ev.eventname}}</div>
                </section>
                <section class="child child-right">
                  <div class="time-holder">
                    <div class="day" v-show="!isDateToday(ev.tsstart) && !isDateTomorrow(ev.tsstart)">{{ ev.tsstart | moment(dateFormats.dayAndMonthUS) }}</div>
                    <div class="day" v-show="isDateToday(ev.tsstart)">{{ $t('BettingOffer.Today') }} </div>
                    <div class="day" v-show="isDateTomorrow(ev.tsstart)">{{ $t('BettingOffer.Tomorrow') }}</div>
                    <div class="time">{{ ev.tsstart | moment(dateFormats.longTime) }}</div>
                  </div>
                  <v-icon>keyboard_arrow_right</v-icon>
                </section>
              </section>
            </div>
          </v-flex>
        </div>
      </div>
    </div>
    <div v-else-if="isLiveEventPage">
      <div class="fast_switch_header">
        <h2><span v-if="liveEventsFoIdFoSportType && liveEventsFoIdFoSportType[0].fosporttypename">{{liveEventsFoIdFoSportType[0].fosporttypename}} - </span>Live Events</h2>
        <v-btn @click="closeDialog()">
          <span>{{ $t('Dialog.btn.CLOSE') }}</span>
        </v-btn>
      </div>
      <div class="events-holder live">
        <div class="event"
            v-for="ev in liveEventsFoIdFoSportType"
            :key="ev.idfoevent"
            :class="{'selected': ev.idfoevent.toString() === idFoEvent.toString()}"
            @click.stop="goToEvent(ev, false, false, false, false, false, idFwMarketgroup)">
          <v-flex class="names participants">
            <div class="event-info">
              <template >
                <section class="parent">
                  <section v-if="ev.homeleadname && ev.awayleadname" class="child child-left">
                    <template v-if="isbig3event">
                      <div class="team-title">{{ ev.awayleadname }}</div>
                      <div class="team-title">{{ ev.homeleadname }}</div>
                    </template>
                    <template v-else>
                      <div class="team-title">{{ ev.homeleadname }}</div>
                      <div class="team-title">{{ ev.awayleadname }}</div>
                    </template>
                  </section>
                  <section v-else-if="(ev.player && ev.player.find(player => !player.type) && (ev.player.find(player => !player.type)).name) && (ev.player && ev.player.find(player => !player.type) && (ev.player.find(player => player.type)).name)" class="child child-left">
                    <div class="team-title">{{ ev.player && ev.player.find(player => !player.type) && (ev.player.find(player => !player.type)).name }}</div>
                    <div class="team-title">{{ ev.player && ev.player.find(player => !player.type) && (ev.player.find(player => player.type)).name }}</div>
                  </section>
                  <section v-else class="child child-left">
                    <div class="team-title">{{ev.eventname}}</div>
                  </section>
                  <section class="live-holder child-right">
                    <span class="live-badge">LIVE</span>
                    <v-icon>keyboard_arrow_right</v-icon>
                  </section>
                </section>
              </template>
            </div>
          </v-flex>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
  import Vue from 'vue'
  import store from '@/store'
  import config from '@/config'
  import BettingOffer from '@/components/mixins/BettingOffer'

  export default {
    name: 'fast-switch',

    props: [
    ],

    components: {
    },

    mixins: [
      BettingOffer
    ],

    data () {
      return {
        periodicalUpdateTimeout: 0,
        isPeriodicalUpdateStarted: false,
        periodicalUpdateInterval: 20000,
        isbig3event: false,
        selectedIDFWMarkettypeclassGroup: 0
      }
    },

    computed: {
      event () {
        return store.getters['eventState/getEvent']
      },
      idfoevent () {
        var idfoevent = this.$route.params.idfoevent && this.$route.params.idfoevent.toString()
        if (idfoevent && idfoevent.indexOf('.') === -1) {
          idfoevent += '.1'
        }

        return idfoevent
      },
      liveEvent () {
        var self = this
        return this.liveEvents.find(ev => ev.idfoevent.toString() === self.idfoevent.toString() || (ev.foeventantepost && ev.foeventantepost.toString() === self.idfoevent.toString()))
      },
      marketgroup () {
        var marketgroups = store.getters['marketgroupState/marketgroups']

        if (marketgroups) {
          let marketgroup = marketgroups[this.idFwMarketgroup]
          if (marketgroup) {
            return marketgroups[this.idFwMarketgroup]
          } else {
            return undefined
          }
        } else {
          return undefined
        }
      },
      recommendedEvents () {
        return store.getters['vaixTabsState/getRecommendedEventsMarketGroup'].events.filter(ev => ev.idfosporttype === this.event.idfosporttype)
      },
      trendingEvents () {
        return store.getters['vaixTabsState/getTrendingEventsMarketGroup'].events.filter(ev => ev.idfosporttype === this.event.idfosporttype)
      },
      marketgroupEvents () {
        if (this.idFwMarketgroup !== 'recommended' && this.idFwMarketgroup !== 'trending') {
          return ((this.marketgroup && Vue._.orderBy(this.marketgroup.events, ['tsstart', 'internalorder', 'participantname_away'])) || [])
        } else if (this.idFwMarketgroup === 'recommended') {
          return ((this.recommendedEvents && Vue._.orderBy(this.recommendedEvents, ['tsstart', 'internalorder', 'participantname_away'])) || [])
        } else if (this.idFwMarketgroup === 'trending') {
          return ((this.trendingEvents && Vue._.orderBy(this.trendingEvents, ['tsstart', 'internalorder', 'participantname_away'])) || [])
        }
      },
      liveEventsFoIdFoSportType () {
        return this.event && Vue._.orderBy(this.liveEvents.filter(ev => ev.idfosporttype === this.event.idfosporttype), ['fosportinternalorder', 'foeventinternalorder', 'awayteamname'])
      },
      isLiveEventPage () {
        return this.liveEvent !== undefined
      },
      idFwMarketgroup () {
        return this.$route.query.idfwmarketgroup
      },
      eventmarketgroups () {
        if (this.event && Array.isArray(this.event.eventmarketgroups)) {
          return Vue._.orderBy(this.event.eventmarketgroups, 'internalorder', 'asc')
        }
        return []
      }
    },

    methods: {
      startMarketgroupByIdUpdate (idfwmarketgroup) {
        this.isPeriodicalUpdateStarted = true
        store.dispatch('marketgroupState/fetchMarketgroupById', idfwmarketgroup).then(() => {
          clearTimeout(this.periodicalUpdateTimeout)
          this.periodicalUpdateTimeout = setTimeout(() => {
            if (this.isPeriodicalUpdateStarted) {
              this.startMarketgroupByIdUpdate(idfwmarketgroup)
            }
          }, this.periodicalUpdateInterval)
        })
      },
      stopMarketgroupByIdUpdate () {
        this.isPeriodicalUpdateStarted = false
        clearTimeout(this.periodicalUpdateTimeout)
      },
      closeDialog () {
        store.dispatch('overlayState/deactivateFastSwitchDialog')
      },
      isBig3 () {
        let isNonBig3FoSportType = config.app.autoconf.BIG3_IGNORE_SPORTTYPES.includes(this.event.idfosporttype)
        if (!isNonBig3FoSportType) {
          let breakLoop = false
          this.eventmarketgroups.forEach(marketgroup => {
            if (breakLoop) return false
            // console.log('first loop')
            marketgroup.markets.forEach(market => {
              if (breakLoop) return false
              // console.log(market, 'market')
              if (market.big3markettype && (market.gameperiod === '1+' || this.displayAllGamePeriodsAsBig3)) {
                // console.log(market.gameperiod + ' ' + market.big3markettype)
                this.isbig3event = true
                breakLoop = true
              }
            })
          })
        }
      }
    },
    mounted () {
      if (this.idFwMarketgroup && this.idFwMarketgroup !== 'trending' && this.idFwMarketgroup !== 'recommended') {
        this.startMarketgroupByIdUpdate(this.idFwMarketgroup)
      }
      this.isBig3()
    },

    destroyed () {
      this.stopMarketgroupByIdUpdate()
      store.dispatch('marketgroupState/cleanMarketgroup', this.idFwMarketgroup)
    },
    watch: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .fast-switcher
    background var(--fast-switch-bgr)
    .fast_switch_header
      background var(--mobile-header-bgr)
      color var(--mobile-header-color)
      height 64px
      display flex
      align-items: center
      justify-content: space-between
      padding 0 10px
      h2
        text-transform: uppercase
        margin-bottom 0
        font-family 'Roboto Condensed Bold'
      .v-btn 
        margin-left 0 
        color var(--fast-switch-accent-color)
        background: transparent
        min-width: auto
        padding: 0
        font-family 'Roboto Condensed Bold'
    .events-holder
      padding 0 10px
      .event
        padding 10px 0px
        &:not(:last-child)
          border-bottom 1px solid var(--fast-switch-borders-color)
    .parent
      display flex
      align-items center
      justify-content space-between
      color var(--fast-switch-color)
      .child-left
        font-family 'Roboto Condensed Bold'
        font-size 14px
        display: flex
        flex-direction column
        margin 0
      .child-right
        display: flex
        align-items center
        color var(--fast-switch-color)
        margin 0
        font-size 14px
        .time-holder
          width auto
          min-width 80px
          padding-right 0px
          font-family 'Roboto Condensed'
          font-size 14px
          text-align: left
        .v-icon
          color var(--fast-switch-color)
          font-size 30px
    .event.selected
      .parent
        color var(--fast-switch-color-selected)

    .live-badge
      background var(--islive-color) !important
      color #fff !important
      border 2px solid var(--islive-color) !important
      font-style normal
      padding 0 5px !important
      font-size 11px
      margin 1px
      border-radius 3px
      font-family: "Roboto Condensed Bold"



</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/fastSwitch.vue